import forEach from 'lodash-es/forEach';
import set from 'lodash-es/set';
import filter from 'lodash-es/filter';
import map from 'lodash-es/map';

const ClassName = {
  BLOCK: 'needs-validation',
};

class FormValidation {
  constructor(elem) {
    this.block = elem;

    this.init();
  }

  // Bootstrap валидация формы
  init() {
    this.block.addEventListener('submit', (event) => this.handler(event));
  }

  handler(event) {
    if (this.block.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.block.classList.add('was-validated');
  }

  static getAllBlocks() {
    return Array.from(document.getElementsByClassName(ClassName.BLOCK));
  }

  static getAllInstances() {
    return map(filter(FormValidation.getAllBlocks(), ({ins}) => ins), (item) => item.ins);
  }

  static initAllBlocks() {
    let Blocks = FormValidation.getAllBlocks();
    forEach(Blocks, (block) => {
      if (block.ins) return;
      block.ins = new FormValidation(block);
    });
  }
}

// Инициашизация;
FormValidation.initAllBlocks();

// Экспорт;
set(window, ['Block', 'FormValidation'], FormValidation);
export default FormValidation;
